// extracted by mini-css-extract-plugin
export default {"containerContainer":"styles_containerContainer__KoPhz","overflowHidden":"styles_overflowHidden__csKZM"};